import React from 'react';
import Logo from '../../public/images/logo.png';

export default () => (
    <div className="logo">
        <img src={Logo} alt="logo" />
    </div>
)